﻿import { SoundSettings } from './SoundSettings';
import { ASSETS } from '../config/assets';

type AppSound = 'click' | 'hover' | 'accept' | 'deny' | 'notification';

const SOUND_FILES: Record<AppSound, string[]> = {
  click:        [...ASSETS.shellAudio.CLICK],
  hover:        [ASSETS.shellAudio.HOVER],
  accept:       [ASSETS.shellAudio.ACCEPT],
  deny:         [ASSETS.shellAudio.DENY],
  notification: [ASSETS.shellAudio.NOTIFICATION],
};

// Cache one Audio object per file path so repeated calls reuse the same element.
const _cache = new Map<string, HTMLAudioElement>();

function getAudio(src: string): HTMLAudioElement {
  let audio = _cache.get(src);
  if (!audio) {
    audio = new Audio(src);
    _cache.set(src, audio);
  }
  return audio;
}

function pickRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

export const AppSoundManager = {
  play(sound: AppSound): void {
    if (!SoundSettings.getSoundEnabled()) return;
    const src   = pickRandom(SOUND_FILES[sound]);
    const audio = getAudio(src);
    audio.currentTime = 0;
    audio.volume = SoundSettings.getEffectsVolume();
    audio.play().catch(() => { /* blocked by autoplay policy or missing file — ignore */ });
  },
};
